import { settingIsEnabled } from 'lib/helpers';
import { Account } from 'types/account';
import { PromptGroup, PromptItemKind } from 'types/candidateStories';

const CANS_SETTING_PREFIX = 'candidateStories';
const GENERAL_INFO = 'GeneralInfo';
const RECORDS_INFO = 'RecordsInfo';

export const isFeatureEnabled = (
  account: Account,
  name: string,
  promptGroup?: PromptGroup,
) => {
  if (!isSettingEnabled(name, account)) {
    return false;
  }

  if (!promptGroup) {
    return true;
  }

  return promptGroup.enabled && promptGroup.items.length > 0;
};

export const isGeneralEnabled = (
  account: Account,
  promptGroup?: PromptGroup,
) => {
  return isFeatureEnabled(account, GENERAL_INFO, promptGroup);
};

export const isRecordsEnabled = (
  account: Account,
  promptGroup?: PromptGroup,
) => {
  return isFeatureEnabled(account, RECORDS_INFO, promptGroup);
};

// Whether the prompt forms render at least one text or file prompt the
// candidate can fill in, given the section's docs/text setting.
export const hasFillablePrompts = (
  setting: unknown,
  promptGroup?: PromptGroup,
) => {
  if (!promptGroup) {
    return false;
  }

  const hasKind = (kind: PromptItemKind) =>
    promptGroup.items.some(item => item.kind === kind);
  const textEnabled = settingIsEnabled(setting, {
    nullish: true,
    keys: ['text'],
  });
  const docsEnabled = settingIsEnabled(setting, {
    nullish: true,
    keys: ['docs'],
  });

  return (
    (textEnabled && hasKind(PromptItemKind.TEXT)) ||
    (docsEnabled && hasKind(PromptItemKind.FILE))
  );
};

export const isSettingEnabled = (name: string, account: Account) => {
  const key = `${CANS_SETTING_PREFIX}${name}` as keyof typeof account;
  const setting = account[key];
  return settingIsEnabled(setting, { nullish: true });
};
